<div
  class="uploader"
  [class.is-uploading]="isUploading"
  libFileDrop
  [accept]="acceptedExtensions"
  (filesDropped)="handleFileInput($event, 'drop')">
  @if (!isUploading) {
    <div class="uploader-center tracking-tight">
      <div class="icon">
        <mat-icon class="w-24 h-24 text-blue-400" svgIcon="file_drop"></mat-icon>
      </div>
      <label class="text-xl lg:text-2xl font-semibold" for="{{ uploadId }}-input">
        {{ 'UPLOADER.DROP_MSG' | translate }}
      </label>
      <p class="max-w-120 text-center text-gray-600 px-4">
        {{ 'UPLOADER.NOTICE' | translate }}
      </p>
      <p class="paste-hint max-w-120 text-center text-gray-500 px-4">
        {{ 'UPLOADER.PASTE_HINT' | translate: { shortcut: pasteShortcut() } }}
      </p>
      @if (allowLocalFileUpload()) {
      <ng-container>
        <button type="button" class="local-upload-button px-4" (click)="openLocalFilePicker($event)">
          {{ 'UPLOADER.LOCAL_UPLOAD' | translate }}
        </button>
        <input
          #localFileInput
          type="file"
          class="local-upload-input"
          accept="{{ acceptedExtensions }}"
          [attr.multiple]="multiple() ? '' : null"
          [disabled]="isUploading"
          (change)="handleLocalInputEvent($event)" />
      </ng-container>
      }
    </div>
  }
  <input
    #fileInput
    id="{{ uploadId }}-input"
    type="file"
    name="UploadFileInput"
    class="uploader-input"
    accept="{{ acceptedExtensions }}"
    [attr.multiple]="multiple() ? '' : null"
    [disabled]="isUploading"
    (change)="handleInputEvent($event)"
    title="" />
  @if (isUploading) {
    <div class="uploader-spinner-overlay" aria-hidden="true">
      <lib-spinner size="lg" variant="primary" />
    </div>
  }
</div>
